// Dependencies
import styled, { css } from 'styled-components'

// Utils
import { MediaQueries } from 'utils/breakpoints'

export const Container = styled.div`
  display: block;
  position: relative;
`

export const StaticContentCompositionWrapper = styled.div`
  ${MediaQueries.amedium} {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  ${MediaQueries.notebook} {
    .sisu-button:first-child {
      width: 176px;
      &:hover {
        background-color: #810a26;
        transition: 0.2s background-color;
      }
    }
  }
`

export const OpenedContent = styled.div<{ isOpened: boolean }>`
  position: absolute;
  top: 96px;
  left: 100%;
  transition: 0.3s left ease-in-out;

  ${MediaQueries.amedium} {
    left: 0;
    top: 0;
    transition: 0.3s top ease-in-out;
  }

  ${({ isOpened }) =>
    !!isOpened &&
    css`
      width: 100%;
      height: 100%;
      z-index: 2;
      left: 0;
      top: 0;

      ${MediaQueries.medium} {
        top: 38px;
      }

      ${MediaQueries.amedium} {
        top: 40px;
        left: 0;
      }

      > {
        position: relative;
        display: flex;
        align-items: center;
        flex-direction: column;

        position: absolute;
        width: 195px;
        top: 54px;

        ${MediaQueries.amedium} {
          position: absolute;
          width: 284px;
          width: max-content;
        }
      }
    `}
`

export const DropdownContentContainer = styled.div`
  display: block;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  z-index: 9;
  background-color: #fff;

  ${MediaQueries.amedium} {
    width: 284px;
    height: fit-content;
    padding: 20px;
    border: 1px solid #571d5d;
    border-radius: 8px;
    box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.1);
  }

  .container {
    display: grid;
    grid-template-columns: 1fr 1fr;

    > {
      padding: 16px 8px;
      text-decoration: none;
      text-align: center;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      color: #7c8195;
      border: 1px solid #eaf4ec;
    }

    ${MediaQueries.amedium} {
      > {
        text-align: start;
        padding: 10px;
        border: 0;

        &:hover {
          color: #df1d3d;
          background-color: #fdf4f5;
        }
      }
    }
  }
`

export const DropdownListContainer = styled.div`
  display: block;
  position: relative;

  .list {
    width: 100%;
    margin-top: 12px;

    .list-item {
      width: 194px;
      border: 1px solid #ced0dd;
      background-color: #fafafc;
      box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
      display: flex;
      align-items: center;
      gap: 16px;

      padding: 16px;

      list-style-type: none;

      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 16px;
      white-space: nowrap;
      text-align: center;

      color: #666b7b;

      cursor: pointer;

      > img {
        max-width: 100%;
        max-height: 100%;
      }

      &:first-child {
        border-radius: 4px 4px 0 0;
        border-bottom: none;
      }

      &:last-child {
        border-bottom: none;
        border-radius: 0 0 4px 4px;
      }

      &:hover {
        background: #f6bec7;
      }
    }
  }
`
